import Swiper from 'swiper';
import {Autoplay, EffectFade, Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

const homeSlider = document.querySelector('.swiper-home');
if (homeSlider) {
    const swiperHome = new Swiper('.swiper-home', {
        // Optional parameters
        direction: 'vertical',
        modules: [Autoplay, EffectFade, Pagination, Navigation],
        slidesPerView: 1,
        effect: 'fade',
        crossFade: true,
        rewind: true,
        speed: 1500,
        touchReleaseOnEdges: true,
        preloadImages: true,
        updateOnImagesReady: true,
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        },

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<button type="button" class="' + className + '"><span class="' + className + '-inner"></span><span class="sr-only">Go to slide ' + (index + 1) + '</span></button>';
            },
        },
        on: {
            autoplayResume() {
                autoplayControl.classList.remove('swiper-autoplay-paused');
            },
        },


        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
    });

    const autoplayControl = document.querySelector(".swiper-autoplay-control");
    autoplayControl.addEventListener('click', (event) => {
        if (swiperHome.autoplay.paused) {
            swiperHome.autoplay.resume();
        } else {
            swiperHome.autoplay.pause();
            autoplayControl.classList.add('swiper-autoplay-paused');
        }
    });
}

const quoteSlider = document.querySelector('.swiper-quote');
if (quoteSlider) {
    const swiperQuote = new Swiper('.swiper-quote', {
        slidesPerView: 'auto',
        modules: [Autoplay, Pagination, Navigation],
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<button type="button" class="' + className + '"><span class="' + className + '-inner"></span><span class="sr-only">Go to slide ' + (index + 1) + '</span></button>';
            },
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            autoplayResume() {
                autoplayControl.classList.remove('swiper-autoplay-paused');
            },
        },

    })
    const autoplayControl = document.querySelector(".swiper-autoplay-control");
    autoplayControl.addEventListener('click', (event) => {
        if (swiperQuote.autoplay.paused) {
            swiperQuote.autoplay.resume();
        } else {
            swiperQuote.autoplay.pause();
            autoplayControl.classList.add('swiper-autoplay-paused');
        }
    });
}

// Slide to the second slide (index 1) immediately after initialization
//swiper.slideTo(0, 0, false); // index, speed (0 for instant), runCallbacks (false)